import { useEffect, useState } from "react";
import api from "@/api";

export default function PartnerBanner() {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/nav-ads").then((r) => setAds(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (ads.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % ads.length), 4000);
    return () => clearInterval(t);
  }, [ads.length]);

  if (ads.length === 0) return null;
  const ad = ads[idx % ads.length];
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/nav-ads-media/${ad.storage_path}`;

  const media = ad.media_type === "video" ? (
    <video key={ad.id} src={url} autoPlay loop muted playsInline className="h-14 sm:h-16 w-auto max-w-[55vw] object-contain" />
  ) : (
    <img key={ad.id} src={url} alt={ad.title || "Partenaire"} className="h-14 sm:h-16 w-auto max-w-[55vw] object-contain" />
  );

  return (
    <div className="bg-white/90 backdrop-blur border-b border-slate-200" data-testid="partner-banner">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-center gap-3">
        <span className="text-[10px] font-semibold uppercase tracking-widest text-slate-400 shrink-0">Publicité · Nos amis</span>
        {ad.link ? (
          <a href={ad.link} target="_blank" rel="noopener noreferrer" data-testid="partner-banner-link">{media}</a>
        ) : (
          media
        )}
        {ad.title && <span className="text-xs font-medium text-slate-600 truncate max-w-[35%]">{ad.title}</span>}
      </div>
    </div>
  );
}
